<script setup lang="ts">
import type { IService } from '@types'
import { usePriceFormatter } from '@booking/utils/prices'
import { ServiceFormats } from '@types'
import { ButtonVariant } from '@ui/styles'
import { getMinPriceByService } from '@utils/priceLibrary/servicePriceSettingsUtils'

withDefaults(
  defineProps<{
    variant?: ButtonVariant
    service?: IService
    showServicePrice?: boolean
    size?: ButtonSizes
  }>(),
  {
    service: () => ({}) as IService,
    showServicePrice: true,
    size: Sizes.HanSolo,
    variant: ButtonVariant.Primary,
  },
)

const { formatPrice } = usePriceFormatter()
</script>

<template lang="pug">
UiButton.white-space-nowrap(
  :size="size"
  :to="`/booking/${service.id}`"
  :variant="variant"
)
  template(v-if="service.format === ServiceFormats.without || !showServicePrice")
    | {{ $t('block.service.info.page.button.booking.text.base') }}
  template(v-else)
    | {{ $t('block.service.info.page.button.booking.text.from') }}
    | {{ formatPrice(getMinPriceByService(service)) }}
</template>
